import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X, Phone, Mail, MapPin, Instagram } from 'lucide-react';
import { mockData } from '../data/mock';
import { Button } from '../components/ui/button';

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setMobileMenuOpen(false);
    }
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-sm border-b border-gray-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <div className="flex items-center">
            <Link to="/" className="flex items-center space-x-3">
              <img 
                src={mockData.company.logo}
                alt="SIA Tīrīšana Logo"
                className="h-12 sm:h-16 w-auto"
              />
              <span className="text-lg sm:text-xl font-bold text-gray-900">
                SIA "Tīrīšana"
              </span>
            </Link>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <button
              onClick={() => scrollToSection('sakums')}
              className="text-gray-600 hover:text-sky-500 transition-colors font-medium"
            >
              Sākums
            </button>
            <button
              onClick={() => scrollToSection('pakalpojumi')}
              className="text-gray-600 hover:text-sky-500 transition-colors font-medium"
            >
              Pakalpojumi
            </button>
            <button
              onClick={() => scrollToSection('par-mums')}
              className="text-gray-600 hover:text-sky-500 transition-colors font-medium"
            >
              Par mums
            </button>
            <button
              onClick={() => scrollToSection('atsauksmes')}
              className="text-gray-600 hover:text-sky-500 transition-colors font-medium"
            >
              Atsauksmes
            </button>
            <button
              onClick={() => scrollToSection('kontakti')}
              className="text-gray-600 hover:text-sky-500 transition-colors font-medium"
            >
              Kontakti
            </button>
          </nav>

          {/* CTA Button */}
          <div className="hidden md:flex items-center space-x-4">
            <a href={`tel:${mockData.company.phone}`} className="text-sky-500 font-semibold flex items-center space-x-2">
              <Phone className="w-4 h-4" />
              <span>{mockData.company.phone}</span>
            </a>
            <Button
              onClick={() => scrollToSection('kontakti')}
              className="bg-sky-500 hover:bg-sky-600 text-white"
            >
              Pieteikt tīrīšanu
            </Button>
          </div>

          {/* Mobile menu button */}
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="md:hidden text-gray-600 hover:text-gray-900"
          >
            {mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div className="md:hidden bg-white border-t border-gray-100">
          <div className="px-4 py-6 space-y-4">
            <button
              onClick={() => scrollToSection('sakums')}
              className="block w-full text-left px-4 py-2 text-gray-600 hover:text-sky-500 hover:bg-sky-50 rounded-lg transition-colors"
            >
              Sākums
            </button>
            <button
              onClick={() => scrollToSection('pakalpojumi')}
              className="block w-full text-left px-4 py-2 text-gray-600 hover:text-sky-500 hover:bg-sky-50 rounded-lg transition-colors"
            >
              Pakalpojumi
            </button>
            <button
              onClick={() => scrollToSection('par-mums')}
              className="block w-full text-left px-4 py-2 text-gray-600 hover:text-sky-500 hover:bg-sky-50 rounded-lg transition-colors"
            >
              Par mums
            </button>
            <button
              onClick={() => scrollToSection('atsauksmes')}
              className="block w-full text-left px-4 py-2 text-gray-600 hover:text-sky-500 hover:bg-sky-50 rounded-lg transition-colors"
            >
              Atsauksmes
            </button>
            <button
              onClick={() => scrollToSection('kontakti')}
              className="block w-full text-left px-4 py-2 text-gray-600 hover:text-sky-500 hover:bg-sky-50 rounded-lg transition-colors"
            >
              Kontakti
            </button>
            <div className="pt-4 border-t border-gray-100">
              <a
                href={`tel:${mockData.company.phone}`}
                className="flex items-center space-x-2 px-4 py-2 text-sky-500 font-semibold"
              >
                <Phone className="w-4 h-4" />
                <span>{mockData.company.phone}</span>
              </a>
              <Button
                onClick={() => scrollToSection('kontakti')}
                className="w-full mt-2 bg-sky-500 hover:bg-sky-600 text-white"
              >
                Pieteikt tīrīšanu
              </Button>
            </div>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
